<template>
  <div :class="{ header: true }">
    <div class='pos'>
      <span :class="{ 'ts': item.type == idx }" @click="handleB(item.type)" v-for="(item, index) of headerList"
        :key="item.type">
        {{ item.name }}
      </span>
    </div>
    <div class="center bigheader">
      <h1 @click="clickFn">
        <img src="@/assets/nav-bar.png" alt="logo" />
      </h1>
      <!-- <h4 class="gywm" @click="handleGo('/system')" >关于我们</h4> -->
      <div class="img-c">
        <img alt="" src="../../assets/img_touxiang.png" class="header_img" @click="handleLogin" />
      </div>
    </div>
  </div>
</template>

<script>
import { getToken } from "utils/storage";
import { mapState } from "vuex";
import { BENDI } from "apiurl/index.js";
import { useInfoApi } from "@/api/login.js";
import M from "minimatch";
export default {
  props: {
    isbig: {
      type: Boolean,
      default: false,
    },
    isAuthor: Boolean,
  },
  data() {
    return {
      headerList: [
        { type: 10, name: '精选推荐' },
        { type: 11, name: '充值中心' },
        { type: 6, name: '关于我们' },
        // { type: 1, name: '用户协议' },
        {type:13,name:"退款中心"},
        { type: 2, name: '隐私协议' },
        { type: 7, name: '退款协议' },
        // { type: 8, name: '自审制度' },
        { type: 9, name: '用户纠纷处理' },
        { type: 4, name: '联系我们' },
        { type: 12, name: '未成年保护制度' },

      ],
      nav_right: [
        {
          name: "个人中心",
          url: "/personal/center",
        },
        {
          name: "作家中心",
          url: "/author",
        },
      ],
      currentRouter: {},
      qqurl: "",
      weixinLogin: "",
      isFixeds: false,
      isshowInfo: true,
      isShowRight: false,
      token: getToken() || null,
      searchValue: null,
      idx: 10,
    };
  },
  watch: {
    $route: {
      handler(n, o) {
        if (!n.query['id']) {
          this.idx = 10
        }
        else
          this.idx = n.query.id
      },
      immediate: true
    }
  },
  methods: {
    clickFn() {
      this.$router.replace('/')
    },
    handleB(b) {
      if (b == 11) {
        this.$router.push({
          path: '/system',
          query: {
            id: b
          }
        })
        return
      }
      if (b != 10)
        this.$router.push({
          path: '/system',
          query: {
            id: b
          }
        })
      else this.$router.push('/')
    },
    handleLogin() {
      useInfoApi().then((res) => {
        if (res.code == 4010) {
          this.$emit("handleLogin", true);
        } else {
          if (this.$route.path == "/user") return;
          this.handleGo("/user");
        }
      });
    },
    gologin() {
      if (!getToken()) {
        this.$router.push({
          path: "/login",
          query: { redirect: this.$route.path },
        });
      }
    },
    goRegister() {
      this.$router.push({
        path: "/register",
        query: { redirect: this.$route.path },
      });
    },
    goCenter() {
      this.$router.push({
        path: "/personal/center",
        query: { redirect: this.$route.path },
      });
    },
    phoneLogin() {
      if (!getToken()) {
        this.$router.push({
          path: "/",
          query: { redirect: this.$route.path },
        });
      }
    },
    /* 退出 */
    logout() {
      this.$store
        .dispatch("LogOut")
        .then((res) => {
          if (res.success) {
            this.$router.push({
              //   path: "/phoneLogin",
              path: "/",
              query: "/",
            });
          }
        })
        .catch(() => { });
    },
    // ==吸顶
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 210) {
        //提前判断要上升多少像素就固定
        this.isFixeds = true;
      } else {
        this.isFixeds = false;
      }
    },
    seeOption() {
      this.isShowRight = true;
    },
    canaleoPtion() {
      this.isShowRight = false;
    },
    goBoxValue() {
      this.$router.push({
        path: "/bookStack",
        query: { searchValue: this.searchValue },
      });
      this.searchValue = null;
    },
  },
  computed: mapState({
    imgurl: (state) => state.user.img,
  }),
  created() {
    // console.log(this.imgurl);
    if (this.pro) {
      this.nav_left = [
        {
          name: "首页",
          url: "/",
        },
        {
          name: "书库",
          url: "/bookStack",
        },
        {
          name: "出版",
          url: "/publishBook",
        },
        {
          name: "充值",
          url: "/personal/myAccount",
        },
        {
          name: "下载APP",
          url: "/download",
        },
        {
          name: "手机站",
          url: "http://m.yuanshixx.com",
        },
      ];
    } else {
      this.nav_left = [
        {
          name: "首页",
          url: "/",
        },
        {
          name: "书库",
          url: "/bookStack",
        },
        {
          name: "出版",
          url: "/publishBook",
        },
        {
          name: "充值",
          url: "/personal/myAccount",
        },
        {
          name: "作家专区",
          url: "/author",
        },
        {
          name: "下载APP",
          url: "/download",
        },
        {
          name: "手机站",
          url: "http://m.yuanshixx.com",
        },
        /*  {
                   name: "充值",
                   url: "/pay"
                 },
                 {
                   name: "作家中心",
                   url: "/author"
                 } */
      ];
    }
  },
  mounted() {
    let backUrl = "/";
    if (this.$route.query.redirect) {
      backUrl = this.$route.query.redirect;
    }
    this.qqurl = `${BENDI}/third/auth/login?thirdType=2&backUrl=${backUrl}`;
    this.weixinLogin = `${BENDI}/third/auth/login?thirdType=3&backUrl=${backUrl}`;
    if (this.$route.path == "/") {
      window.addEventListener("scroll", this.handleScroll);
    }
  },
};
</script>

<style lang="stylus" scoped>
.gywm{
  position: absolute
  right:200px
  top:34px
  font-weight: 400
  cursor pointer
}
@import '~@/styles/cominxin.styl'
.img-c
  width 70px
  height 70px !important
  background: #666
  border-radius: 50%
  position: absolute
  right: 100px
  top:6px
  cursor pointer
  .header_img
            width 54px
            height 54px
            margin: 6px auto 0 6px

.router-link-exact-active
    color #48A2DF
    .line
        width 34px
        height 3px
        background rgba(72, 162, 223, 1)
        border-radius 4px
        position absolute
        bottom 25px
        left 50%
        margin-left -17px
        display inline-block
input
    border none
    outline none
.header
    width 100%
    background #fff
    position relative
    .center
        width 100%
        position relative
        height 84px

        h1
            width 100%
            height 84px
            text-align: center
            img
                width 100%
                height 100%

    .pos{
      position: absolute
      width 50%
      right: 200px
      top:50%
      transform: translateY(-50%)
      z-index:100
      color: #666
      cursor pointer

      span{
        margin-left:20px
        font-size:14px
      }
    }
    .ts{
      font-weight:600
      font-size:20px
      color: black
      position relative
      z-index: 999
      &::after{
          content: ""
          position: absolute
          width :40px
          bottom: -24px
          left: 50%
          transform: translateX(-50%)
          height: 3px
          background: linear-gradient(to right,red,pink)
      }
    }
</style>
